import img01 from '../../../assets/image/dummy-images/dummy20.png'
import img03 from '../../../assets/image/dummy-images/dummy24.png'
import img04 from '../../../assets/image/dummy-images/dummy22.png'
import img05 from '../../../assets/image/other-images/kitchen_printer.jpg'
import img06 from '../../../assets/image/dummy-images/dummy23.png'
import img07 from '../../../assets/image/other-images/standing-kiosk-extra-product.png'
import img08 from '../../../assets/image/other-images/clamp-kiosk-extra-product.png'
import posImage from '../../../assets/image/other-images/pos.jpg'
import counterTopKioskImage from '../../../assets/image/other-images/counterkiosk.png'
import wallMountKioskImage from '../../../assets/image/other-images/wall_mount_kiosk.png'

// Kiosk types key will be the key name of the plan options it has the suffix '_included' for distinction.
export const KIOSK_INCLUDED_TYPE = {
  STANDING_KEY: 'ssk_standing_included',
  COUNTER_KEY: 'ssk_countertop_included',
  CLAMP_KEY: 'ssk_clamp_included',
  WALL_MOUNT_KEY: 'ssk_wall_mount_included',
}

export const KIOSK_INCLUDED_CONFIG = {
  [KIOSK_INCLUDED_TYPE.STANDING_KEY]: {
    label: 'Standing Kiosk',
    value: KIOSK_INCLUDED_TYPE.STANDING_KEY,
    data: {
      img: img01,
      dimensions: 'H:5 ft | W:8.5 inch | L:19 inch',
      weight: '60lbs',
      title: 'Revi Standing Self-Service Kiosk',
      description: `
          Serve more customers by using the Revi Standing Self-Service Kiosk.
          The Standing Kiosk allows this self-service station to be anywhere in your location.
          Revi highly recommends the Standing Kiosk for businesses with a permanent location.
      `,
    }
  },
  [KIOSK_INCLUDED_TYPE.COUNTER_KEY]: {
    label: 'Counter Kiosk',
    value: KIOSK_INCLUDED_TYPE.COUNTER_KEY,
    data: {
      img: counterTopKioskImage,
      dimensions: 'H:12 inch | W:17 inch | L:23 inch',
      weight: '18lbs',
      title: 'Revi Counter Top Self-Service Kiosk',
      description: `
          Serve more customers by using the Revi Standing Self-Service Kiosk.
          The Counter Top Self-Service Kiosk allows this self-service station to be closer to your register
          or on a table top. Revi highly recommends the Counter Top Self-Service Kiosk for businesses with a permanent location.
      `,
    }
  },
  [KIOSK_INCLUDED_TYPE.CLAMP_KEY]: {
    label: 'Clamp Kiosk',
    value: KIOSK_INCLUDED_TYPE.CLAMP_KEY,
    data: {
      img: img03,
      dimensions: 'H:7 inch | W:12.5 inch | L:16 inch',
      weight: '12lbs',
      title: 'Revi Clamp Kiosk',
      description: `
          The Revi Clamp kiosk is a recommended setup for food trucks, mobile carts, and other unique environments.
          The clamp can attach to structural elements or window frames, as well the case protects your self-serve kiosk and/or POS.
          This provides easy setup & take down when closed for the day and attracts customers with video or a backsplash of your incredible food.
      `,
    }
  },
  [KIOSK_INCLUDED_TYPE.WALL_MOUNT_KEY]: {
    label: 'Wall Mount Kiosk',
    value: KIOSK_INCLUDED_TYPE.WALL_MOUNT_KEY,
    data: {
      img: wallMountKioskImage,
      dimensions: 'H | 9.3 in, W | 13.4 in, D | 1 in',
      weight: '2.50 lbs',
      title: 'Revi Wall Mount Kiosk',
      description: `Serve more customers and display your self-ordering kiosk with the Revi Wall Mounting Kit. Perfect for tablets up to 13 inches, it includes an enclosure, stand, and wall mount for flexible placement. The adjustable design makes positioning easy, while the key-lock keeps your device safe. Ideal for businesses looking for a clean, professional setup.`,
    }
  },
}

// TODO: Update this flow when the backend is updated. We need to get only one option for each add on with the different price types.
// Add on key will be the key name of the plan options but with the suffix '_monthly' or '_upfront' depending on the price type.

export const ADD_ON_KEY = {
  STANDING_KEY: 'ssk_standing',
  COUNTER_KEY: 'ssk_countertop',
  CLAMP_KEY: 'ssk_clamp',
  KITCHEN_PRINTER_KEY: 'kdsprinter',
  KITCHEN_DISPLAY_TABLET_KEY: 'kds8.7',
  KITCHEN_HUB_KEY: 'kitchen_hub',
  HANDHELD_KEY: 'handhelds',
  POS_KEY: 'pos_10',
  WALL_MOUNT_KEY: 'ssk_wall_mount',
}

export const ADD_ON_CONFIG = {
  [ADD_ON_KEY.STANDING_KEY]: {
    img: img07,
    descriptionList: ["12.9 iPad, 4G", "Credit card reader"],
    details: "Serve more customers by using the Revi Standing Self-Service Kiosk. The Standing Kiosk allows this self-service station to be anywhere in your location. Revi highly recommends the Standing Kiosk for businesses with a permanent location.",
  },
  [ADD_ON_KEY.COUNTER_KEY]: {
    img: counterTopKioskImage,
    descriptionList: ["12.9 iPad, 4G", "Credit card reader"],
    details: "Serve more customers by using the Revi Standing Self-Service Kiosk.The Counter Top Self-Service Kiosk allows this self-service station to closer to your register or on a table top. Revi highly recommends the Counter Top Self-Service Kiosk for businesses with a permanent location.",
  },
  [ADD_ON_KEY.CLAMP_KEY]: {
    img: img08,
    descriptionList: ["12.9 iPad, 4G", "Credit card reader"],
    details: "The Revi Clamp kiosk is a recommended setup for food trucks, mobile carts, and other unique environments. The clamp can attach to structural elements or window frames, as well the case protects your self serve kiosk and/or POS. This provides easy setup & take down when closed for the day and attract customers with video or a backsplash of your incredible food.",
  },
  [ADD_ON_KEY.KITCHEN_PRINTER_KEY]: {
    img: img05,
    details: "Our Kitchen printer offers high quality labels, barcode, and receipt printing in one compact unit. It features fast print speeds up and prints at a clear resolution.It handles a variety of print stock for labels, receipts, QR codes, tickets, and offerscontinuous printing on liner labels.",
  },
  [ADD_ON_KEY.KITCHEN_DISPLAY_TABLET_KEY]: {
    img: img04,
    descriptionList: ["Additional 4G 8.7 in Tablet"],
    details: "Easily split orders and menu items to different tablets with flexibility for your kitchen's unique needs.",
  },
  [ADD_ON_KEY.KITCHEN_HUB_KEY]: {
    img: img06,
    details: "Control and consolidate online orders from all of your delivery providers to just one Kitchen Display Tablet (KDS). Seamlessly connect all of your sales channels directly through our integration.",
  },
  [ADD_ON_KEY.HANDHELD_KEY]: {
    img: posImage,
    details: "The Revi iPad Handheld puts the full power of your POS in the palm of your hand, so you can take and fire orders from anywhere. Move faster, serve more guests, and keep the line moving without being tied to a counter.",
  },
  [ADD_ON_KEY.POS_KEY]: { 
    img: posImage,
    details: "The Revi 10” iPad POS combines a large, easy-to-use touchscreen with a cash drawer and reliable and secure card reader. It’s everything you need to take payments, print receipts, and keep orders flowing—all in one sleek, dependable setup.",
  },
  [ADD_ON_KEY.WALL_MOUNT_KEY]: {
    img: wallMountKioskImage,
    details: `Serve more customers and display your self-ordering kiosk with the Revi Wall Mounting Kit. Perfect for tablets up to 13 inches, it includes an enclosure, stand, and wall mount for flexible placement. The adjustable design makes positioning easy, while the key-lock keeps your device safe. Ideal for businesses looking for a clean, professional setup.`,
  },
}